
//import arrow from './assets/arrow.png'
import React from 'react';
import { Link } from 'react-router-dom';
function Footer() {


    return (<>
        <div className=" containers  ">
            <footer class="footer">
                <div class="footer__addr">
                    <h2>Futura Care</h2>
                    <p>Futura fornisce assistenza sanitaria progressiva e conveniente, accessibile su dispositivi mobili e online per tutti.<br /></p>
                </div>

                <ul class="footer__nav">
                    <li class="nav__item">
                        <h2 class="nav__title">Futura Care</h2>
                        <ul class="nav__ul">
                            <li>
                                <Link to="/servizi">Servizi</Link>
                            </li>

                            <li>
                                <Link to="/lavora-con-noi">Lavora con noi</Link>
                            </li>

                            <li>
                                <Link to="/chi-siamo">Chi siamo</Link>
                            </li>
                        </ul>
                    </li>



                    <li class="nav__item">
                        <h2 class="nav__title">Aspetti legati</h2>

                        <ul class="nav__ul">
                            <li  >
                                <Link to="/privacy">Privacy Policy</Link>
                            </li>

                            <li  >
                                <Link to="/termini">Termini e condizioni</Link>
                            </li>


                        </ul>
                    </li>
                </ul>
                <div style={{ textAlign: 'center', margin: '25px 0' }}>

                    <div class="main">
                        <div class="footer-wrapper">
                            <a class="footer-icon facebook" href="https://www.facebook.com/futuracare/" rel="noreferrer" target="_blank">
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px"
                                    viewBox="0 0 512 512" fill="#385C8E" style={{ enableBackground: "new 0 0 512 512" }} xmlSpace="preserve">
                                    <g>
                                        <path d="M134.941,272.691h56.123v231.051c0,4.562,3.696,8.258,8.258,8.258h95.159c4.562,0,8.258-3.696,8.258-8.258V273.78h64.519c4.195,0,7.725-3.148,8.204-7.315l9.799-85.061c0.269-2.34-0.472-4.684-2.038-6.44c-1.567-1.757-3.81-2.763-6.164-2.763h-74.316V118.88c0-16.073,8.654-24.224,25.726-24.224c2.433,0,48.59,0,48.59,0c4.562,0,8.258-3.698,8.258-8.258V8.319c0-4.562-3.696-8.258-8.258-8.258h-66.965C309.622,0.038,308.573,0,307.027,0c-11.619,0-52.006,2.281-83.909,31.63c-35.348,32.524-30.434,71.465-29.26,78.217v62.352h-58.918c-4.562,0-8.258,3.696-8.258,8.258v83.975C126.683,268.993,130.379,272.691,134.941,272.691z" />
                                    </g>
                                </svg>
                            </a>
                            <a class="footer-icon twitter" href="https://twitter.com/CareFutura" rel="noreferrer" target="_blank">
                                <svg version="1.1" viewBox="0 0 512 512" width="35px" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="#2CA7E0">
                                    <g>
                                        <path d="M485.98,113.141c-16.923,7.506-35.109,12.578-54.197,14.858    c19.48-11.679,34.445-30.171,41.49-52.208c-18.234,10.814-38.43,18.668-59.925,22.899c-17.213-18.341-41.738-29.799-68.88-29.799    c-52.114,0-94.368,42.25-94.368,94.364c0,7.396,0.834,14.598,2.444,21.505c-78.427-3.936-147.962-41.504-194.504-98.597    c-8.123,13.937-12.777,30.146-12.777,47.441c0,32.739,16.659,61.623,41.98,78.546c-15.469-0.491-30.02-4.735-42.742-11.804    c-0.009,0.395-0.009,0.788-0.009,1.188c0,45.721,32.529,83.859,75.698,92.531c-7.918,2.156-16.255,3.311-24.861,3.311    c-6.081,0-11.992-0.593-17.755-1.693c12.009,37.488,46.858,64.773,88.153,65.533c-32.296,25.312-72.985,40.396-117.198,40.396    c-7.617,0-15.128-0.446-22.511-1.32c41.762,26.775,91.365,42.4,144.655,42.4c173.574,0,268.493-143.794,268.493-268.496    c0-4.091-0.092-8.16-0.273-12.208C457.332,148.684,473.33,132.064,485.98,113.141z" style={{ fillRule: 'evenodd', clipRule: 'evenodd' }} />
                                    </g>
                                </svg>
                            </a>
                            <a class="footer-icon linkedin" href="https://www.linkedin.com/company/futura-care-srl" rel="noreferrer" target="_blank">
                                <svg style={{ enableBackground: "new 0 0 64 64" }} version="1.1" viewBox="0 0 64 64" xmlSpace="preserve" width="35px" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="#0072FF">
                                    <g>
                                        <path d="M8,54.7C8,55.4,8.6,56,9.3,56h9.3c0.7,0,1.3-0.6,1.3-1.3V23.9c0-0.7-0.6-1.3-1.3-1.3H9.3   c-0.7,0-1.3,0.6-1.3,1.3V54.7z" />
                                        <path d="M46.6,22.3c-4.5,0-7.7,1.8-9.4,3.7c-0.4,0.4-1.1,0.1-1.1-0.5l0-1.6c0-0.7-0.6-1.3-1.3-1.3h-9.4   c-0.7,0-1.3,0.6-1.3,1.3c0.1,5.7,0,25.4,0,30.7c0,0.7,0.6,1.3,1.3,1.3h9.5c0.7,0,1.3-0.6,1.3-1.3V37.9c0-1,0-2,0.3-2.7c0.8-2,2.6-4.1,5.7-4.1c4.1,0,6,3.1,6,7.6v15.9c0,0.7,0.6,1.3,1.3,1.3h9.3c0.7,0,1.3-0.6,1.3-1.3V37.4C60,27.1,54.1,22.3,46.6,22.3z" />
                                        <path d="M13.9,18.9L13.9,18.9c3.8,0,6.1-2.4,6.1-5.4C19.9,10.3,17.7,8,14,8c-3.7,0-6,2.3-6,5.4   C8,16.5,10.3,18.9,13.9,18.9z" />
                                    </g>
                                </svg>
                            </a>
                            <a class="footer-icon instagram" href="https://instagram.com/futuracare_" rel="noreferrer" target="_blank">
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="35px"
                                    viewBox="0 0 551.034 551.034" xmlSpace="preserve">
                                    <g>
                                        <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="275.517" y1="4.57" x2="275.517" y2="549.72" gradientTransform="matrix(1 0 0 -1 0 554)">
                                            <stop offset="0" style={{ stopColor: "#E09B3D" }} />
                                            <stop offset="0.3" style={{ stopColor: "#C74C4D" }} />
                                            <stop offset="0.6" style={{ stopColor: "#C21975" }} />
                                            <stop offset="1" style={{ stopColor: "#7024C4" }} />
                                        </linearGradient>
                                        <path class="insta-square" style={{ fill: 'url(#SVGID_1_)' }} d="M386.878,0H164.156C73.64,0,0,73.64,0,164.156v222.722
                                 c0,90.516,73.64,164.156,164.156,164.156h222.722c90.516,0,164.156-73.64,164.156-164.156V164.156
                                 C551.033,73.64,477.393,0,386.878,0z M495.6,386.878c0,60.045-48.677,108.722-108.722,108.722H164.156
                                 c-60.045,0-108.722-48.677-108.722-108.722V164.156c0-60.046,48.677-108.722,108.722-108.722h222.722
                                 c60.045,0,108.722,48.676,108.722,108.722L495.6,386.878L495.6,386.878z"/>

                                        <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="275.517" y1="4.57" x2="275.517" y2="549.72" gradientTransform="matrix(1 0 0 -1 0 554)">
                                            <stop offset="0" style={{ stopColor: "#E09B3D" }} />
                                            <stop offset="0.3" style={{ stopColor: "#C74C4D" }} />
                                            <stop offset="0.6" style={{ stopColor: "#C21975" }} />
                                            <stop offset="1" style={{ stopColor: "#7024C4" }} />
                                        </linearGradient>
                                        <path style={{ fill: 'url(#SVGID_2_)' }} d="M275.517,133C196.933,133,133,196.933,133,275.516s63.933,142.517,142.517,142.517
                                 S418.034,354.1,418.034,275.516S354.101,133,275.517,133z M275.517,362.6c-48.095,0-87.083-38.988-87.083-87.083
                                 s38.989-87.083,87.083-87.083c48.095,0,87.083,38.988,87.083,87.083C362.6,323.611,323.611,362.6,275.517,362.6z"/>

                                        <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="418.31" y1="4.57" x2="418.31" y2="549.72" gradientTransform="matrix(1 0 0 -1 0 554)">
                                            <stop offset="0" style={{ stopColor: "#E09B3D" }} />
                                            <stop offset="0.3" style={{ stopColor: "#C74C4D" }} />
                                            <stop offset="0.6" style={{ stopColor: "#C21975" }} />
                                            <stop offset="1" style={{ stopColor: "#7024C4" }} />
                                        </linearGradient>
                                        <circle style={{ fill: 'url(#SVGID_3_)' }} cx="418.31" cy="134.07" r="34.15" />
                                    </g>
                                </svg>
                            </a>
                        </div>
                    </div>


                </div>
                <div class="legal" style={{ justifyContent: 'center' }}>
                    <p>Futura Care S.r.l. - Via circumvallazione 310. 80035 Nola (NA) - P.Iva 09828331216 &copy; 2022 - Tutti i diritti riservati</p>

                </div>






            </footer>

        </div>
    </>
    );
}


export default Footer;